import type { ControlInspector } from "./types"

export const datePicker: ControlInspector<"datePicker"> = {
  Inspector: () => null,
}
